export const studentinputs = [
  {
    EducationDetails: [
      {
        label: "Academic Year Id",
        type: "select",
        key: "academicYearId",
        required: true
      },
      {
        label: "Admission Date",
        type: "date", // fixed typo from 'dete'
        key: "admissionDate",
        required: true
      },
      {
        label: "RollNo",
        type: "text",
        key: "rollNo",
        required: true
      },
      {
        label: "Class",
        type: "select",
        key: "schoolClassId",
        required: true
      },
      {
        label: "Section",
        type: "select",
        key: "classSectionId",
        required: true
      },
    ],
    PersonalDetails: [
      // {
      //   label: "Profile Image",
      //   type: "file",
      //   key: "profileImage",
      //   mandatory: false
      // },
      {
        label: "Face Image",
        type: "file",
        key: "faceImage",
        required: false
      },
      {
        label: "Full Name",
        type: "text",
        key: "firstName",
        required: true
      },
      {
        label: "Last Name",
        type: "text",
        key: "lastName",
        required: true
      },
      {
        label: "Email",
        type: "email",
        key: "email",
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        required: true,
        errorMessage: "Please enter a valid email address"
      },
      {
        label: "Date of Birth",
        type: "date",
        key: "dob",
        required: true
      },
      {
        label: "Blood Group",
        type: "select",
        key: "bloodGroup",
        required: true
      },
      {
        label: "Gender",
        type: "select",
        key: "gender",
        required: true
      },
      {
        label: "Religion",
        type: "select",
        key: "religion",
        required: true
      },
      {
        label: "Caste",
        type: "text",
        key: "caste",
        required: true
      },
      {
        label: "Caste Category",
        type: "select",
        key: "casteCategory",
        required: true
      },
      {
        label: "Mother Tongue",
        type: "select",
        key: "motherTongue",
        required: true
      },
      {
        label: "Aadhar Number",
        type: "text",
        key: "aadharNumber",
        pattern: "^\\d{12}$",
        maxLength: 12,
        required: true,
        errorMessage: "Aadhar number must be exactly 12 digits"
      },
      {
        label: "Aadhar Status",
        type: "select",
        key: "aadharStatus",
        required: true
      },
      {
        label: "MDM Enrolled",
        type: "radio",
        key: "mdmEnrolled",
        required: true
      }
    ],
    FamilyDetails: [
      {
        label: "Father Name",
        type: "text",
        key: "fatherName",
        required: true
      },
      {
        label: "Father Aadhar",
        type: "text",
        key: "fatherAadhar",
        pattern: "^\\d{12}$",
        maxLength: 12,
        required: true,
        errorMessage: "Aadhar number must be exactly 12 digits"
      },
      {
        label: "Mother Name",
        type: "text",
        key: "motherName",
        required: true
      },
      {
        label: "Mother Aadhar",
        type: "text",
        key: "motherAadhar",
        pattern: "^\\d{12}$",
        maxLength: 12,
        required: true,
        errorMessage: "Aadhar number must be exactly 12 digits"
      },
      {
        label: "Primary Contact No",
        type: "tel",
        key: "primaryContactNo",
        pattern: "^\\d{10}$",
        maxLength: 10,
        required: true,
        errorMessage: "Phone number must be exactly 10 digits"
      },
      {
        label: "Secondary Contact No",
        type: "tel",
        key: "secondaryContactNo",
        pattern: "^\\d{10}$",
        maxLength: 10,
        required: true,
        errorMessage: "Phone number must be exactly 10 digits"
      }
    ],
    AddressDetails: [
      {
        label: "Address",
        type: "text",
        key: "address",
        required: true
      }
    ],
    MedicalDetails: [
      {
        label: "Physically Challenged",
        type: "radio",
        key: "physicallyChallenged",
        required: true
      }
    ]
  },
];

export const teacherinputs = [
  {
    label: "Face Image",
    type: "file",
    key: "faceImage",
    required: false
  },
  {
    label: "First Name",
    type: "text",
    key: "firstName",
    required: true
  },
  {
    label: "Last Name",
    type: "text",
    key: "lastName",
    required: true
  },
  {
    label: "Email",
    type: "email",
    key: "email",
    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    required: true,
    errorMessage: "Please enter a valid email address"
  },
  {
    label: "Phone",
    type: "tel",
    key: "phone",
    pattern: "^\\d{10}$",
    maxLength: 10,
    required: true,
    errorMessage: "Phone number must be exactly 10 digits"
  },
  {
    label: 'Designation',
    type: 'select',
    key: 'designation',
    required: true
  },
  {
    label: "Aadhar Number",
    type: "text",
    key: "aadharNumber",
    pattern: "^\\d{12}$",
    maxLength: 12,
    required: true,
    errorMessage: "Aadhar number must be exactly 12 digits"
  },
];

export const admininputs = [
  {
    label: "Profile Image",
    type: "file",
    key: "profileImage",
    required: false
  },
  {
    label: "First Name",
    type: "text",
    key: "firstName",
    required: true
  },
  {
    label: "Last Name",
    type: "text",
    key: "lastName",
    required: true
  },
  {
    label: "Email",
    type: "email",
    key: "email",
    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    required: true,
    errorMessage: "Please enter a valid email address"
  },
  {
    label: "Phone",
    type: "tel",
    key: "phone",
    pattern: "^\\d{10}$",
    maxLength: 10,
    required: true,
    errorMessage: "Phone number must be exactly 10 digits"
  },
  {
    label: 'Designation',
    type: 'select',
    key: 'designation',
    required: true
  },
  {
    label: "Aadhar Number",
    type: "text",
    key: "aadharNumber",
    pattern: "^\\d{12}$",
    maxLength: 12,
    required: true,
    errorMessage: "Aadhar number must be exactly 12 digits"
  },
];